/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IRegionData, IRegionDataState, IRegionOptionList } from "Interfaces/SiteContent";

/**
 * Region data selector.
 */
export const getRegions = (state: IRegionDataState): IRegionData[] => state.regions;

/**
 * Region option list data selector.
 */
export const getRegionsOptionList = (state: IRegionDataState): IRegionOptionList[] =>
  state.regionOptionList;

/**
 * Region option list data selector.
 */
export const getRegionLoadError = (state: IRegionDataState): string => state.regionLoadError;
